<div *ngIf="!offerExpire">
  <div 
    class="cont-offers position-relative" 
    [ngClass]="{
      'border-star':product?.braze?.extras?.star,
      'first-card': isFirst
    }"
  >
    <img *ngIf="product?.braze?.extras?.star" class="image-start" src="/assets/svg/start-offers.svg" alt="start">
    <div class="cont-offers__cont-section">
      <app-product-image class="cont-offers__image"
                        [isAlgolia]="isAlgolia"
                        [product]="product"
                        [isSustitutes]="isSustitutes"
                        [isMini]="isMini"
                        [isCard]="true"
                        [isHome]="isHome"
                        [browser]="browser"
                        [lazyLoaded]="lazyLoaded"
                        [queryID]="queryID"
                        [positions]="positions + 1"
                        [isFlashOffer]="true">
      </app-product-image>

      <div class="cont-offers__cont-description" 
        [ngClass]="{'start-description':product?.braze?.extras?.star}"  
        *ngIf="product?.fullPrice">
        <div (click)="goDetail(product)">
          <p class="cont-offers__text-title">{{product.description | titlecase }}</p>
          <p class="cont-offers__text-description"> {{product.detailDescription | titlecase }}</p>
            <div class="cont-price">
              <h2 class="cont-offers__text-price" *ngIf="showPrice()">
                {{ showPriceText() | multiCountryCurrency }}
              </h2>
            </div>
            <span *ngIf="product.primePrice && product.primePrice > 0 && primeData?.active" 
              class="cont-offers__text-price" 
              [ngStyle]="{'color' : primeData?.active ? primeStyles?.primary_dark_color : '#418fde' }">
              {{product.primePrice  | multiCountryCurrency }}
            </span>
            <p *ngIf="showOfferPrice()"
              class="cont-offers__text-offer-price">
                {{product.fullPrice | multiCountryCurrency}} 
            </p>
            <div *ngIf="showContainerPetal()">
              <app-prime-petal-long
                  *ngIf="showPrimePetal()"
                  [customClasses]="'prime-petal-long--price'"
                  [value]="product.primePrice">
               </app-prime-petal-long>
            </div>
          <div class="bz-rating" [ngClass]="{'hide-r': hideRating() }">
            <div data-bv-show="inline_rating" [attr.data-bv-product-id]="product.id" data-bv-seo="false"></div>
          </div>
        </div>
        <app-quantity-controls
          *ngIf="!isSustitutes"
          class="add-button"
          [idPrefix]="idPrefix"
          [product]="product"
          [isCard]="true"
          [isMiniCard]="isMini"
          [isLorealDesign]="isLorealDesign"
          [isHome]="isHome"
          [isVTO]="isVTO"
          [queryID]="queryID"
          [positions]="positions + 1"
          [isFlashOffer]="true"
        ></app-quantity-controls>
      </div>

      <div class="cont-description" [ngClass]="{'start-description':product?.braze?.extras?.star}"  *ngIf="product?.type === 'GROUP'" >
        <div>
          <p class="cont-offers__text-title cont-offers__cont-group">{{product.description | titlecase }}</p>
          <button (click)="goToGroup()" class="cont-offers__btn-blue">Ver más</button>
        </div>
      </div>
    </div>

    <div class="d-flex" *ngIf="!product?.braze?.extras?.star" (click)="goDetail(product)">
      <div class="cont-offers__information-promotion">
        <p class="cont-offers__text-title-down">¡No lo dejes pasar!</p>
        <p class="cont-offers__text-subtitle">Tiempo restante:</p>
      </div>
      <div class="cont-offers__time">
        <ng-container *ngTemplateOutlet="timeCircle; context: {label: 'Días', number:day}" ></ng-container>
        <ng-container *ngTemplateOutlet="timeCircle; context: {label: 'Hrs', number:hours}" ></ng-container>
        <ng-container *ngTemplateOutlet="timeCircle; context: {label: 'Mins', number:minutes}" ></ng-container>
        <ng-container *ngTemplateOutlet="timeCircle; context: {label: 'Seg', number:seconds}" ></ng-container>
        <ng-template  #timeCircle let-label="label" let-number="number">
          <div class="cont-offers__time-circle">
            <img src="/assets/svg/border-yellow.svg" *ngIf="offerTime(false)" alt="Tiempo de oferta">
            <img src="/assets/svg/border-orange.svg" *ngIf="offerTime(true)" alt="Tiempo de oferta">
            <p class="cont-offers__date-time" [ngClass]="{'cont-offers__time-orange':offerTime(true)}"> <span *ngIf="number < 10">0</span>{{number}}</p>
            <p class="cont-offers__text-center">{{label}}</p>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="cont-offers__cont-quantity" (click)="goDetail(product)">
      <div class="flex-1"></div>
      <div class="cont-offers__cont-progress"  
        [ngClass]="{'mt-unit':product?.fullPrice}" 
        [ngClass]="{'start-progress':product?.braze?.extras?.star}">
        <p class="cont-offers__cont-progress-text" [ngClass]="{'orange':offerTime(true)}">
          {{product?.braze.extras.availableStockFlash}} disponibles 
        </p>
        <div class="cont-offers__progress-bar">
          <div class="cont-offers__progress-bar-item" 
            [ngClass]="{'progress-orange':offerTime(true) }"   
            [ngStyle]="{'width':valuePercentageBar}">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>